(() => {
  function initHeaderSearchExpand() {
    const sectionHeader =
      document.querySelector('.section-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper');

    if (!sectionHeader) return;

    const input =
      sectionHeader.querySelector('#Search-In-Header') ||
      sectionHeader.querySelector('.header__search input[type="search"]') ||
      sectionHeader.querySelector('input[type="search"]');

    if (!input) return;

    const searchRoot =
      input.closest('predictive-search') ||
      input.closest('.header__search') ||
      input.closest('search-form');

    if (!searchRoot) return;

    const form = input.closest('form');
    const resetBtn = form ? form.querySelector('button[type="reset"]') : null;
    const headerActions = sectionHeader.querySelector('.header-actions');
    const loginBtn = sectionHeader.querySelector('.header__icon--account');
    const cartBtn =
      sectionHeader.querySelector('#cart-icon-bubble') ||
      sectionHeader.querySelector('.header__icon--cart');
    const drawerBtn = sectionHeader.querySelector('.header__icon--menu');
    const logoBlock =
      sectionHeader.querySelector('.header__heading') ||
      sectionHeader.querySelector('.header__heading-link');

    let isExpanded = false;
    let isResetting = false;
    let blurTimer = null;

    function openSearch() {
      if (isExpanded) return;
      isExpanded = true;
      sectionHeader.classList.add('header-search-expanded');
    }

    function closeSearch(force = false) {
      if (!isExpanded) return;

      const hasText = input.value.trim().length > 0;
      const activeInsideSearch = searchRoot.contains(document.activeElement);

      if (!force && (hasText || activeInsideSearch || isResetting)) return;

      isExpanded = false;
      sectionHeader.classList.remove('header-search-expanded');
    }

    input.addEventListener('focus', openSearch);

    searchRoot.addEventListener('mousedown', (e) => {
      if (e.target.closest('button[type="reset"]')) return;
      openSearch();
    });

    searchRoot.addEventListener('click', (e) => {
      if (e.target.closest('button[type="reset"]')) return;
      if (document.activeElement !== input) {
        input.focus({ preventScroll: true });
      }
    });

    input.addEventListener('input', () => {
      if (input.value.trim()) {
        openSearch();
      }
    });

    if (resetBtn) {
      resetBtn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        isResetting = true;
      });

      resetBtn.addEventListener('click', (e) => {
        e.preventDefault();

        isResetting = true;
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));

        requestAnimationFrame(() => {
          input.focus({ preventScroll: true });
          isResetting = false;
        });
      });
    }

    input.addEventListener('blur', () => {
      if (blurTimer) clearTimeout(blurTimer);

      blurTimer = setTimeout(() => {
        if (isResetting) return;
        closeSearch(false);
      }, 140);
    });

    document.addEventListener('mousedown', (e) => {
      const clickedInsideSearch = searchRoot.contains(e.target);
      const clickedInsideActions = headerActions && headerActions.contains(e.target);
      const clickedDrawer = drawerBtn && drawerBtn.contains(e.target);
      const clickedLogo = logoBlock && logoBlock.contains(e.target);
      const clickedLogin = loginBtn && loginBtn.contains(e.target);
      const clickedCart = cartBtn && cartBtn.contains(e.target);

      if (!clickedInsideSearch && !clickedInsideActions && !clickedDrawer && !clickedLogo && !clickedLogin && !clickedCart) {
        closeSearch(true);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        input.blur();
        closeSearch(true);
      }
    });

    [loginBtn, cartBtn, drawerBtn].forEach((btn) => {
      if (!btn) return;

      // e.preventDefault() evita que o foco vá para o botão (previne :focus-within)
      // O click ainda dispara normalmente — a navegação funciona
      btn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeSearch(true);
      });

      // Proteção extra: se o botão receber foco programaticamente
      // (ex: drawer do carrinho fechando e devolvendo foco),
      // retira o foco imediatamente para não disparar expansão CSS
      btn.addEventListener('focus', () => {
        requestAnimationFrame(() => {
          if (document.activeElement === btn) {
            btn.blur();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSearchExpand);
  } else {
    initHeaderSearchExpand();
  }
})();